"use strict";

/**
 * Войсы для чтения на странице
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveVoiceEnum = void 0;
var ResponsiveVoiceEnum;
(function (ResponsiveVoiceEnum) {
  ResponsiveVoiceEnum["default"] = "UK English Male";
  ResponsiveVoiceEnum["english"] = "UK English Male";
  ResponsiveVoiceEnum["arabic"] = "Arabic Male";
  ResponsiveVoiceEnum["chinese"] = "Chinese Female";
  ResponsiveVoiceEnum["czech"] = "Czech Female";
  ResponsiveVoiceEnum["danish"] = "Danish Male";
  ResponsiveVoiceEnum["deutsch"] = "Deutsch Female";
  ResponsiveVoiceEnum["dutch"] = "Dutch Male";
  ResponsiveVoiceEnum["finnish"] = "Finnish Female";
  ResponsiveVoiceEnum["french"] = "French Female";
  ResponsiveVoiceEnum["greek"] = "Greek Female";
  ResponsiveVoiceEnum["hindi"] = "Hindi Female";
  ResponsiveVoiceEnum["hungarian"] = "Hungarian Female";
  ResponsiveVoiceEnum["indonesian"] = "Indonesian Female";
  ResponsiveVoiceEnum["italian"] = "Italian Female";
  ResponsiveVoiceEnum["japanese"] = "Japanese Female";
  ResponsiveVoiceEnum["korean"] = "Korean Female";
  ResponsiveVoiceEnum["norwegian"] = "Norwegian Female";
  ResponsiveVoiceEnum["polish"] = "Polish Female";
  ResponsiveVoiceEnum["portuguese"] = "Portuguese Male";
  ResponsiveVoiceEnum["romanian"] = "Romanian Female";
  ResponsiveVoiceEnum["russian"] = "Russian Female";
  ResponsiveVoiceEnum["spanish"] = "Spanish Female";
  ResponsiveVoiceEnum["swedish"] = "Swedish Female";
  ResponsiveVoiceEnum["thai"] = "Thai Female";
  ResponsiveVoiceEnum["turkish"] = "Turkish Female";
  ResponsiveVoiceEnum["vietnamese"] = "Vietnamese Female";
})(ResponsiveVoiceEnum = exports.ResponsiveVoiceEnum || (exports.ResponsiveVoiceEnum = {}));
